exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chat-queues-multiselect[data-v-a9e3e8c4] {\n  font-size: 14px;\n}\n.chat-queues-multiselect[data-v-a9e3e8c4] .multiselect__tags {\n  padding: 5px 40px 0 8px;\n  max-height: 37px;\n  min-height: unset;\n  border-radius: unset;\n  border: 1px solid lightgray;\n}\n.chat-queues-multiselect[data-v-a9e3e8c4] .multiselect__single {\n  font-size: small;\n}", ""]);

// exports
